<div class="modal-header blue">
  <div class="d-flex align-items-center">
    <h4 class="modal-title mr-3">
      {{
        isReadOnly
          ? 'Payer Setup'
          : isEditMode
            ? 'View/Modify Payer Setup'
            : 'Add Payer Setup'
      }}
    </h4>
  </div>

  <a
    href="javascript:void(0)"
    class="modal-close-btn"
    (click)="close()"
    aria-label="javascript"
  ></a>
</div>

<form
  [formGroup]="payerForm"
  class="modal-body"
  [class.disabled]="isReadOnly"
  [class.loading]="isLoading"
>
  <div class="form-row md mb-3">
    <div class="col-5">
      <div class="row">
        <div class="col">
          <div class="input-label">SC Insurance ID</div>
          <input
            formControlName="id"
            type="text"
            placeholder="Enter  SC Insurance ID"
            class="input"
          />
        </div>

        <div class="col">
          <div class="input-label required">Payer id</div>
          <input
            type="text"
            formControlName="neicId"
            placeholder="Enter Payer ID"
            class="input"
          />
        </div>
      </div>
    </div>

    <div class="col">
      <div class="input-label">Alternate Payer ID</div>
      <input
        type="text"
        formControlName="cardId"
        placeholder="Enter Alternate Payer ID"
        class="input"
      />
    </div>

    <div class="col">
      <div class="input-label">last DB update</div>
      <datepicker formControlName="dateLastDbUpdate"> </datepicker>
    </div>

    <div class="col">
      <div class="d-flex align-items-start">
        <div class="flex-container">
          <checkbox
            formControlName="recordStatus"
            class="mb-2"
            checkedValue="A"
            uncheckedValue="D"
            (change)="onRecordStatusChange($event)"
          >
            Active
          </checkbox>

          <checkbox
            formControlName="legacy"
            checkedValue="Y"
            uncheckedValue="N"
            (change)="onRecordStatusChange($event)"
          >
            Legacy
          </checkbox>
        </div>

        <a
          href="javascript:void(0);"
          *ngIf="!isReadOnly"
          class="add-group-btn ml-auto"
          [class.disabled]="isReadOnly || !isEditMode"
          (click)="addInsurance()"
        >
          <i class="fas fa-plus fz-16 mr-2"></i>
          <span> Add Insurance </span>
        </a>
      </div>
    </div>
  </div>

  <div class="form-row md mb-3">
    <div class="col-5">
      <div class="input-label">claim filing indicator</div>

      <claim-filing-indicators-select formControlName="claimFilingIndicator">
      </claim-filing-indicators-select>
    </div>

    <div class="col">
      <div class="input-label">state</div>
      <states formControlName="payorState"> </states>
    </div>

    <div class="col">
      <div class="input-label">setup update</div>

      <datepicker formControlName="dateSetup"> </datepicker>
    </div>

    <div class="col">
      <div class="input-label">Inactive Date</div>

      <datepicker formControlName="dateTerminate"> </datepicker>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="form-row md mb-3">
        <div class="col-6">
          <div class="input-label">Payer Name</div>
          <input
            type="text"
            formControlName="name"
            placeholder="Enter Payer Name"
            class="input"
          />
        </div>
        <div class="col-6" formGroupName="contact">
          <div class="input-label">Payer Contact</div>
          <input
            type="text"
            formControlName="name"
            placeholder="Enter Payer Contact"
            class="input"
          />
        </div>
      </div>
      <div class="form-row md mb-3" formGroupName="contact">
        <div class="col-6">
          <div class="input-label">Phone</div>
          <input
            type="text"
            formControlName="phone"
            placeholder="Enter Phone"
            class="input"
          />
        </div>
        <div class="col-6">
          <div class="input-label">Fax</div>
          <input
            type="text"
            formControlName="fax"
            placeholder="Enter FAX"
            class="input"
          />
        </div>
      </div>
      <div class="form-row md mb-3">
        <div class="col-6">
          <div class="input-label">Professional Processor ID</div>
          <input
            formControlName="processorId"
            placeholder="Enter Professional Processor ID"
            type="text"
          />
        </div>

        <div class="col-6">
          <div class="input-label">Institutional Processor ID</div>
          <input
            type="text"
            placeholder="Enter Institutional Processor ID"
            formControlName="ubProcessorId"
          />
        </div>
      </div>
      <div class="form-row md mb-3">
        <div class="col-6">
          <div class="input-label">Attachment Processor ID</div>
          <input
            type="text"
            placeholder="Enter Attachment Processor ID"
            formControlName="attachmentsProcessorId"
          />
        </div>

        <div class="col-6">
          <div class="row">
            <div class="col">
              <div class="input-label">Eligibility ID</div>
              <input
                type="text"
                formControlName="realTimeId"
                placeholder="Enter Eligibility"
                class="input"
              />
            </div>

            <div class="col">
              <div class="input-label">claim status id</div>
              <input
                type="text"
                placeholder="Enter Claim Status Id"
                formControlName="claimStatusId"
                class="input"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="form-row md mb-3">
        <div class="col">
          <div class="input-label mb-2">Professional TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="neicPayerType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="neicPayerType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="neicPayerType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>

        <div class="col">
          <div class="input-label mb-2">Institutional TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="institutionalType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="institutionalType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="institutionalType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>

        <div class="col">
          <div class="input-label mb-2">ERA TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eraType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eraType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eraType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>
      </div>

      <div class="form-row md mb-3">
        <div class="col">
          <div class="input-label mb-2">Eligibility TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eligibilityType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eligibilityType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="eligibilityType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>

        <div class="col">
          <div class="input-label mb-2">Claim Status TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="claimStatusType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="claimStatusType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="claimStatusType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>

        <div class="col">
          <div class="input-label mb-2">Attachment TYPE</div>

          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="attachmentType" value="P" />
            <span class="text">Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="attachmentType" value="N" />
            <span class="text">Non-Participating</span>
          </label>
          <label class="input-wrap radio mb-2">
            <input type="radio" formControlName="attachmentType" value="D" />
            <span class="text">Direct</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="form-row mb-3">
        <div class="col-12">
          <div class="input-label">Claim Status Receiver/Source Output</div>

          <div class="input-wrap select">
            <select
              class="input"
              formControlName="billingIndicator"
              aria-label="billingIndicator"
            >
              <option [value]="''" selected="selected">
                Select Claim Status Receiver/Source Output
              </option>
              <option
                *ngFor="let sourceOutput of sourceOutputs"
                [value]="sourceOutput.value"
              >
                {{ sourceOutput.value + ' - ' + sourceOutput.description }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-row mb-3">
        <div class="col-8">
          <div class="input-label mb-2">Enrollments required</div>

          <div class="row">
            <div class="col flex-container">
              <checkbox
                class="mb-2"
                formControlName="requiresEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                Professional
              </checkbox>

              <checkbox
                class="mb-2"
                formControlName="eligibilityEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                Eligibility
              </checkbox>

              <checkbox
                formControlName="eraEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                ERA
              </checkbox>
            </div>

            <div class="col flex-container">
              <checkbox
                class="mb-2"
                formControlName="institutionalEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                Institutional
              </checkbox>

              <checkbox
                class="mb-2"
                formControlName="claimStatusEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                Claim Status
              </checkbox>

              <checkbox
                formControlName="attachmentEnrollment"
                checkedValue="Y"
                uncheckedValue="N"
              >
                Attachments
              </checkbox>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="input-label">Folowup# of days</div>
          <input
            type="text"
            mask="0*"
            formControlName="followUpNumberOfDays"
            placeholder="Enter Folowup# of days"
            class="input"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col">
          <div class="input-label mb-2">Additional Transactions</div>

          <div class="flex-container">
            <checkbox
              formControlName="secondaryClaims"
              class="d-inline-block mb-2"
              checkedValue="S"
              uncheckedValue="N"
            >
              Secondary Claims
            </checkbox>
            <checkbox
              class="d-inline-block"
              formControlName="batchClaimStatus"
              checkedValue="Y"
              uncheckedValue="N"
            >
              Batch Claim Status
            </checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6">
      <div class="flex-container flex-fill">
        <div class="input-label">Notes</div>
        <div class="input-wrap h-100">
          <textarea
            class="h-100"
            placeholder="Enter Notes"
            formControlName="notes"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="modal-footer">
  <button
    class="button w-100px ml-auto"
    *ngIf="!isReadOnly"
    [disabled]="payerForm.invalid"
    (click)="save()"
  >
    {{ isEditMode ? 'Save' : 'Add Payer' }}
  </button>
</div>
